import { render, staticRenderFns } from "./labeling-strategy-config.vue?vue&type=template&id=ef5ef018"
import script from "./labeling-strategy-config.vue?vue&type=script&lang=ts"
export * from "./labeling-strategy-config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports